import React from 'react';

const Footer = () => {
  return (
    <>
    <div className="footerBox">
      
<ul class="tt-socail">
<li><a target="_blank" href="mailto:swander926@icloud.com"><i class="fa fa-mail" aria-hidden="true"></i></a></li>
<li><a target="_blank" href="https://www.github.com/swander926"><i class="fa fa-github" aria-hidden="true"></i></a></li>
<li><a target="_blank" href="https://www.linkedin.com/in/nathanaelswander"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
<li><a target="_blank" href="https://medium.com/@swander926"><i class="fa fa-medium" aria-hidden="true"></i></a></li>
</ul>
    </div>
</>
  );
}

export default Footer;
